// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".is-disabled[data-v-66056502]{opacity:.5}.is-disabled-text[data-v-66056502]{color:#aaa}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/manufactures/components/UserListDialog.vue"],"names":[],"mappings":"AACA,8BACC,UAAA,CAGD,mCACC,UAAA","file":"UserListDialog.vue","sourcesContent":["\n.is-disabled {\n\topacity: 0.5;\n}\n\n.is-disabled-text {\n\tcolor: #aaa;\n}\n"]}]);
// Exports
module.exports = exports;
